// extracted by mini-css-extract-plugin
export default {"wrapper":"pagination_wrapper__f5Q7C"};